import React from 'react'
import { UserX } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import store from '../../state/store'

class TutorRejector extends React.Component {

  onReject = () => {
    store.emit('tutoring_job:tutor_results:reject', {
      tutor_id: this.props.tutor_result.tutor.id,
      tutoring_job_id: this.props.tutoring_job.id
    })

    this.onClose()
  }

  onClose = () => {
    store.emit('ui:tutor_rejector:close')
  }

  render() {
    return (
      <Card className="my-4">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <UserX className="size-4"/>
            Reject Tutor
          </CardTitle>
        </CardHeader>
        <CardContent className="text-muted-foreground">
          Reject {this.props.tutor_result.tutor.name} for this job?
        </CardContent>
        <CardFooter className="justify-end gap-2">
          <Button variant="outline" size="sm" onClick={this.onClose}>Close</Button>
          <Button variant="destructive" size="sm" onClick={this.onReject}>Reject Tutor</Button>
        </CardFooter>
      </Card>
    )
  }
}

export default TutorRejector
